import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import Icon from '@/units/Icon';
import styled from 'styled-components';
import dayjs from 'dayjs';

export const isJSON = (string_) => {
  try {
    JSON.parse(string_);
    return true;
  } catch {
    return false;
  }
};

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: '1px solid #EAECF0',
  borderRadius: '8px',
  '&.Mui-expanded': {
    border: `1px solid #EAECF0`,
    borderRadius: '8px',
  },
  '& .MuiPaper-root': {
    background: '#F9F9F9',
  },
  '& .MuiAccordionSummary-root': {
    background: '#F9F9F9',
    paddingRight: '14px',
    border: 'none',
  },
  '& .MuiAccordionDetails-root': {
    background: '#F9F9F9',
    border: 'none',
  },
}));

const DetailItem = ({ label, value }) => {
  const getPriorityColor = (priority) => {
    if (priority === 'מיידי') return 'red';
    if (priority === 'גבוה- תוך 3 ימים') return 'orange';
    if (priority === 'בינוני - תוך 3 שבועות') return 'yellow';
    if (priority === 'נמוך - תוך 8 שבועות') return 'blue';
  };

  if (label === 'Priority') {
    const priorityLabel = value;
    return (
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="body1" sx={{ color: '#344054' }}>
          {label}
        </Typography>
        <Box display="flex" alignItems="center">
          {priorityLabel && (
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: getPriorityColor(priorityLabel),
                marginRight: '8px',
              }}
            />
          )}
          <Typography variant="body1" sx={{ fontWeight: '500', color: '#101828' }}>
            {priorityLabel || 'N/A'}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Typography variant="body1" sx={{ color: '#344054' }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: '500', color: '#101828' }}>
        {value || 'N/A'}
      </Typography>
    </Box>
  );
};

export const SAPDetails = ({ SAPFields }) => {
  const details = isJSON(SAPFields) ? JSON.parse(SAPFields) : SAPFields;

  return (
    <StyledAccordion>
      <AccordionSummary expandIcon={<Icon.ChevronDown sx={{ fontSize: '20px', marginRight: '7px', color: '#667085' }} />}>
        <Typography variant="h6">Details</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ padding: '14px', paddingLeft: 0 }}>
          <DetailItem label="Equipment" value={details?.equipment} />
          <DetailItem label="Functional location" value={details?.functionalLocation} />
          <DetailItem label="Fault type" value={details?.noteType} />
          <DetailItem label="Equipment failure" value={details?.equipmentFailure} />
          <DetailItem label="Fault Source" value={details?.faultSource} />
          <DetailItem label="End date" value={dayjs(details?.endDate).format('MMMM D, hh:mm A')} />
          <DetailItem label="Created at" value={dayjs(details?.createdAt).format('MMMM D, hh:mm A')} />
          {/* TEMPORARY COMMENTED OUT BECAUSE BAZAN DO NOT ACCEPT THIS FIELD IN REPORT */}
          {/* <DetailItem
            label="Assignee"
            value={
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  {details?.assignee !== 'null' && (
                    <Avatar
                      sx={{
                        bgcolor: '#2055ff',
                        color: 'white',
                        border: '1px solid #D1D1D1',
                        height: '25px',
                        width: '25px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        lineHeight: 1,
                      }}
                    >
                      {getInitials(details?.assignee || 'Guest')}
                    </Avatar>
                  )}
                </Grid>
                <Grid item>
                  <Typography variant="body1" sx={{ fontWeight: '500', color: '#101828' }}>
                    {details?.assignee !== 'null' ? details?.assignee : 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            }
          /> */}
          <DetailItem label="Priority" value={details?.priority} />
        </Box>
      </AccordionDetails>
    </StyledAccordion>
  );
};
